export default function TickerLink({ticker}) {
    return (
        <a href={"https://www.tradingview.com/symbols/"+ticker} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
            {ticker}
        </a>
    );
}